/**
 * TAMIX SAAS PLATFORM - Navigation Sidebar
 * ========================================
 * Generated: 2025-09-22 - Session 6 Sprint 0
 * Left navigation with role-based menu items
 */

import React from 'react'
import { NavLink } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

const Sidebar: React.FC = () => {
  const { user } = useAuthStore()

  // Navigation items based on user role
  const getNavigationItems = () => {
    const baseItems = [
      {
        to: '/dashboard',
        icon: 'fas fa-tachometer-alt',
        label: 'Dashboard',
        roles: ['platform_admin', 'tenant_admin', 'manager', 'evaluator', 'employee']
      }
    ]

    const adminItems = [
      {
        to: '/tenants',
        icon: 'fas fa-building',
        label: 'Gestión de Tenants',
        roles: ['platform_admin']
      }
    ]

    const tenantItems = [
      {
        to: '/evaluations',
        icon: 'fas fa-clipboard-list',
        label: 'Evaluaciones',
        roles: ['tenant_admin', 'manager', 'evaluator']
      },
      {
        to: '/employees',
        icon: 'fas fa-users',
        label: 'Empleados',
        roles: ['tenant_admin', 'manager']
      },
      {
        to: '/reports',
        icon: 'fas fa-chart-bar',
        label: 'Reportes',
        roles: ['tenant_admin', 'manager']
      }
    ]

    const allItems = [...baseItems, ...adminItems, ...tenantItems]
    
    return allItems.filter(item => 
      user?.role && item.roles.includes(user.role)
    )
  }

  const navigationItems = getNavigationItems()

  return (
    <aside className="bg-dark text-white" style={{ width: '250px', minHeight: '100vh' }}>
      {/* Sidebar Header */}
      <div className="p-3 border-bottom border-secondary">
        <div className="d-flex align-items-center">
          <div className="bg-primary rounded p-2 me-3">
            <i className="fas fa-brain text-white"></i>
          </div>
          <div>
            <h6 className="mb-0 fw-bold">TAMIX</h6>
            <small className="text-muted">Plataforma SaaS</small>
          </div>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="py-3">
        <ul className="list-unstyled">
          {navigationItems.map((item) => (
            <li key={item.to} className="mb-1">
              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  `d-flex align-items-center px-3 py-2 text-decoration-none text-white hover-bg-secondary ${
                    isActive ? 'bg-primary' : ''
                  }`
                }
              >
                <i className={`${item.icon} me-3`}></i>
                <span>{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>

        {/* Divider */}
        <hr className="border-secondary mx-3" />

        {/* Additional Menu Items */}
        <ul className="list-unstyled">
          <li className="mb-1">
            <NavLink
              to="/settings"
              className={({ isActive }) =>
                `d-flex align-items-center px-3 py-2 text-decoration-none text-white hover-bg-secondary ${
                  isActive ? 'bg-primary' : ''
                }`
              }
            >
              <i className="fas fa-cog me-3"></i>
              <span>Configuración</span>
            </NavLink>
          </li>
          
          <li className="mb-1">
            <NavLink
              to="/help"
              className={({ isActive }) =>
                `d-flex align-items-center px-3 py-2 text-decoration-none text-white hover-bg-secondary ${
                  isActive ? 'bg-primary' : ''
                }`
              }
            >
              <i className="fas fa-question-circle me-3"></i>
              <span>Ayuda</span>
            </NavLink>
          </li>
        </ul>
      </nav>

      {/* Sidebar Footer */}
      <div className="mt-auto p-3 border-top border-secondary">
        <div className="d-flex align-items-center">
          <div className="text-muted small">
            <div className="fw-semibold">{user?.tenant?.name || 'Sistema'}</div>
            <div>Rol: {user?.role}</div>
          </div>
        </div>
      </div>
    </aside>
  )
}

export default Sidebar